import { CLASSES, type DungeonView } from '@xox/shared'
import { Coins, Heart, Shield, Skull, Sword } from 'lucide-react'

/** Health, attack and defence, hero level, gold and kills, floor and turn: the run at a glance. */
export function Hud({ view }: { view: DungeonView }) {
  const h = view.hero
  const hp = Math.max(0, h.hp / h.maxHp)
  const xp = Math.min(1, h.xp / Math.max(1, h.nextXp))
  return (
    <div className="flex w-full max-w-[400px] flex-col gap-1.5 text-sm">
      <div className="flex items-center justify-between gap-2">
        <span className="font-black">
          {CLASSES[h.cls].name} <span className="text-slate-500">Lv {h.level}</span>
        </span>
        <span className="text-xs text-slate-500">
          Floor {view.floor} · turn {view.turn}
        </span>
      </div>
      <div
        className="h-3 overflow-hidden rounded-full bg-slate-200 dark:bg-slate-800"
        role="progressbar"
        aria-label={`${h.hp} of ${h.maxHp} health`}
        aria-valuemin={0}
        aria-valuemax={h.maxHp}
        aria-valuenow={h.hp}
      >
        <div
          className={`h-full rounded-full transition-[width] duration-200 ${hp < 0.35 ? 'bg-rose-500' : 'bg-emerald-500'}`}
          style={{ width: `${hp * 100}%` }}
        />
      </div>
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs tabular-nums text-slate-600 dark:text-slate-300">
        <span className="inline-flex items-center gap-1 font-semibold">
          <Heart className="size-3.5 text-rose-500" aria-hidden /> {h.hp}/{h.maxHp}
        </span>
        <span className="inline-flex items-center gap-1">
          <Sword className="size-3.5" aria-hidden /> {h.atk}
        </span>
        <span className="inline-flex items-center gap-1">
          <Shield className="size-3.5" aria-hidden /> {h.def}
        </span>
        <span className="inline-flex items-center gap-1">
          <Coins className="size-3.5 text-amber-500" aria-hidden /> {view.gold}
        </span>
        <span className="inline-flex items-center gap-1">
          <Skull className="size-3.5" aria-hidden /> {view.kills}
        </span>
        <span className="ml-auto inline-flex items-center gap-1.5">
          XP
          <span className="inline-block h-1.5 w-16 overflow-hidden rounded-full bg-slate-200 dark:bg-slate-800">
            <span
              className="block h-full rounded-full bg-sky-500"
              style={{ width: `${xp * 100}%` }}
            />
          </span>
        </span>
      </div>
    </div>
  )
}
